import request from '../request'

export const studentStoryApi = {
  listStudentStory (params) {
    return request.get('/studentStories', { params: params })
  },
  saveStudentStory (data) {
    return request.post('/studentStory', data)
  },
  deleteStudentStory (id) {
    return request.delete('/studentStories/' + id)
  },
  getStudentStory (id) {
    return request.get('/studentStories/' + id)
  },
  updateStudentStory (id, data) {
    return request.put('/studentStories/' + id, data)
  },
}

export default studentStoryApi
